<template>
  <div>
    <mdbRow class="align-items-center">
      <mdbCol>
        <mdbInput
          v-model="phoneNumber"
          :label="$t('find_member_old_phonenumber_input_label')"
          :small="$t('find_member_old_phonenumber_input_small')"
          type="text"
        />
      </mdbCol>
      <mdbCol>
      <mdbBtn color="indigo" @click="findPhoneNumber">{{
        $t("find_member_old_phonenumber_button")
      }}</mdbBtn>
      </mdbCol>
    </mdbRow>
  </div>
</template>

<script>
import { mdbRow, mdbCol, mdbBtn, mdbInput } from "mdbvue";
export default {
  name: "FindMemberPhonenumbers",
  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbInput
  },
  data() {
    return {
      phoneNumber: "",
      retrivebyphonepath: "/1.0/front/customer/retrieve/tel/"
    };
  },
  methods: {
    phoneSearch(val) {
      this.findPhoneNumber(val);
    },
    findPhoneNumber() {
      this.$http
        .get(this.retrivebyphonepath + this.phoneNumber)
        .then(response => {
          if (response.status == 200) {
            this.$emit("customer-loaded", response.data.customers)
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch(error => {
          return error;
        });
    }
  }
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
